module.exports = __webpack_public_path__ + "img/large.6d97999c.jpg";